export var application = {
  name: 'Portal de Arrecadação - SIA-PR',
  version: ' - ',
  description:
    'Portal de Arrecadação - SIA-PR',
  brandLogoPath: 'https://www.pr.gov.br/logos/governo/logo-governo-h.svg',
  framework: {
    name: 'Framework Vue.js Celepar',
    version: '1.0'
  },
  developer: {
    name: 'Celepar',
    href: 'http://www.celepar.pr.gov.br',
    logo: 'https://www.pr.gov.br/logos/governo/logo-governo-h.svg'
  },
  customer: {
    name: 'Secretaria de Estado da Fazenda',
    href: 'http://www.fazenda.pr.gov.br',
    showInHeader: false
  },
  credits: [
    {
      name: 'vue-the-mask',
      href: 'https://vuejs-tips.github.io/vue-the-mask/',
      description: 'Máscaras de campos'
    },
    {
      name: 'axios',
      href: 'https://github.com/axios/axios',
      description: 'Cliente HTTP para browser e Node.js'
    },
    {
      name: 'portal-vue',
      href: 'https://github.com/LinusBorg/portal-vue',
      description:
        'Componente de renderização de DOM em qualquer parte do documento'
    },
    {
      name: 'vue-backtotop',
      href: 'https://github.com/caiofsouza/vue-backtotop',
      description: 'Componente para exibição de botão para ir ao topo'
    },
    {
      name: 'click-outside',
      href: 'https://github.com/vue-bulma/click-outside',
      description: 'Diretiva para tratamento de cliques externos'
    },
    {
      name: 'vue-json-to-csv',
      href: 'https://github.com/angeliquekom/vue-json-to-csv',
      description: 'Componente para converter e baixar JSON em CSV'
    },
    {
      name: 'vue-router',
      href: 'https://router.vuejs.org/',
      description: 'Componente de rotas oficial do Vue.js'
    },
    {
      name: 'vuex',
      href: 'https://vuex.vuejs.org/',
      description: 'Biblioteca de gerenciamento de estados oficial do Vue.js'
    }
  ]
}
